module.exports = __webpack_public_path__ + "img/camera-circle.8d6145be.png";